import { useEffect, useState } from "react";
import { Printer, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { TermPrintCard } from "@/components/TermPrintCard";

export default function PrintGlossary() {
  const [terms, setTerms] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [subject, setSubject] = useState("");
  const [withComics, setWithComics] = useState(true);

  useEffect(() => {
    api.get("/terms").then((r) => setTerms(r.data));
    api.get("/subjects").then((r) => setSubjects(r.data));
  }, []);

  if (!terms) return <div className="flex justify-center py-24"><Loader2 className="h-8 w-8 animate-spin" /></div>;
  const list = terms.filter((t) => !subject || t.subject === subject);

  return (
    <main className="mx-auto max-w-4xl px-5 pb-24 pt-10 sm:px-8 print:max-w-none print:p-0" data-testid="print-page">
      <div className="ink-box mb-10 flex flex-wrap items-center gap-3 rounded-3xl bg-white p-5 print:hidden">
        <select value={subject} onChange={(e) => setSubject(e.target.value)} data-testid="print-subject-select" className="rounded-full border-2 border-[var(--ink)] px-4 py-2 font-extrabold">
          <option value="">Tutte le materie</option>
          {subjects.map((s) => <option key={s}>{s}</option>)}
        </select>
        <label className="flex items-center gap-2 font-bold">
          <input type="checkbox" checked={withComics} onChange={(e) => setWithComics(e.target.checked)} data-testid="print-with-comics" className="h-4 w-4" /> Includi fumetti
        </label>
        <button onClick={() => window.print()} data-testid="print-button" className="ink-box-sm ink-press ml-auto flex items-center gap-2 rounded-full bg-[var(--sky)] px-5 py-2 font-extrabold text-white">
          <Printer className="h-4 w-4" /> Stampa / Salva PDF
        </button>
        <p className="w-full text-xs font-semibold text-neutral-500">Nella finestra di stampa scegli "Salva come PDF" per scaricare il file.</p>
      </div>

      <header className="mb-8 border-b-[3px] border-black pb-4">
        <h1 className="font-display text-4xl font-bold">Glossario di terza media</h1>
        <p className="font-bold text-neutral-600">{subject || "Tutte le materie"} · {list.length} parole</p>
      </header>

      <div className="space-y-6" data-testid="print-list">
        {list.length === 0 && <p className="rounded-2xl border-2 border-dashed border-neutral-400 p-8 text-center font-bold" data-testid="print-empty">Nessuna parola in questa materia.</p>}
        {list.map((t) => <TermPrintCard key={t.id} term={t} withComic={withComics} />)}
      </div>
    </main>
  );
}
